/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAssetPriceOptions,
  GetAssetPriceStatus200,
  GetAssetPriceStatus400,
  GetAssetPriceStatus404,
  GetAssetPriceStatus500,
} from '../types/GetAssetPrice'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAssetPrice } from '../clients/getAssetPrice'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAssetPriceQueryKey = ({ path }: Omit<GetAssetPriceOptions, 'headers'>) =>
  [{ url: '/v1/price/asset/:asset_id', params: path }] as const

type GetAssetPriceQueryKey = ReturnType<typeof getAssetPriceQueryKey>

export function getAssetPriceQueryOptions(
  { path }: GetAssetPriceOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAssetPriceQueryKey({ path })
  return queryOptions<
    GetAssetPriceStatus200,
    ResponseErrorConfig<GetAssetPriceStatus400 | GetAssetPriceStatus404 | GetAssetPriceStatus500>,
    GetAssetPriceStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAssetPrice({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get the current price of an asset
 * {@link /v1/price/asset/:asset_id}
 */
export function useGetAssetPrice<
  TData = GetAssetPriceStatus200,
  TQueryData = GetAssetPriceStatus200,
  TQueryKey extends QueryKey = GetAssetPriceQueryKey,
>(
  { path }: { path: GetAssetPriceOptions['path'] | (() => GetAssetPriceOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAssetPriceStatus200,
        ResponseErrorConfig<
          GetAssetPriceStatus400 | GetAssetPriceStatus404 | GetAssetPriceStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getAssetPriceQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getAssetPriceQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetAssetPriceStatus400 | GetAssetPriceStatus404 | GetAssetPriceStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
